"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taaEvents = void 0;
var taaEvents;
(function (taaEvents) {
    taaEvents["SUBMIT_PUNCH"] = "submit_punch";
    taaEvents["SUBMIT_MISSED_PUNCH"] = "submit_missed_punch";
    taaEvents["DELETE_PUNCH"] = "delete_punch";
    taaEvents["GET_PUNCHES"] = "get_punches";
    taaEvents["GET_UNIFIED_PUNCHES"] = "get_unified_punches";
    taaEvents["GET_PAY_PERIOD"] = "get_pay_period";
    taaEvents["GET_PAY_PERIOD_RANGE"] = "get_pay_period_range";
    taaEvents["GET_PUNCH_CORRECTIONS"] = "get_punch_corrections";
    taaEvents["GET_PAY_PERIOD_CALENDAR"] = "get_pay_period_calendar";
    taaEvents["GET_PAY_CALENDAR"] = "get_pay_calendar";
    taaEvents["GET_SCHEDULE"] = "get_schedule";
    taaEvents["GET_PAY_DATA"] = "get_pay_data";
    taaEvents["PEOPLE_TECH_FEATURE_GATE_SERVICE"] = "people_tech_feature_gate_service";
    taaEvents["GET_PAY_CODES"] = "get_pay_codes";
    taaEvents["GET_PAY_CODES_SUMMARY"] = "get_pay_codes_summary";
    taaEvents["ADD_PAY_CODE"] = "add_pay_code";
    taaEvents["EDIT_PAY_CODE"] = "edit_pay_code";
    taaEvents["GET_ANOMALY_SEARCH"] = "get_anomaly_search";
    taaEvents["CREATE_CTK_CASE"] = "create_ctk_case";
})(taaEvents = exports.taaEvents || (exports.taaEvents = {}));
